import Link from 'next/link';
import React from 'react';
import { ChevronRight } from 'lucide-react';
import { quickLinks } from './data';

export default function NavigationLinks(): React.ReactNode {
  return (
    <div className='flex w-full lg:w-1/2 lg:justify-end'>
      <div className='flex w-full flex-col gap-y-5 lg:w-auto'>
        <h3 className='text-base font-semibold text-white md:text-lg'>
          Quick Links
        </h3>
        {quickLinks.map((item, index) => (
          <Link
            key={`${item.name}_${index}`}
            href={item.href}
            className='flex items-center justify-between gap-x-2 text-sm font-medium text-gray-300 hover:text-white'
          >
            {item.name}
            <ChevronRight className='block lg:hidden' />
          </Link>
        ))}
      </div>
    </div>
  );
}
